import useSWRImmutable from "swr/immutable";

import { fetchMostPopularArticlesData } from "./apis";

export const useGetMostPopularArticlesData = () => {
  const { data } = useSWRImmutable("most-popular-articles", fetchMostPopularArticlesData, {
    refreshInterval: 0,
    revalidateOnMount: true,
  });

  if (!data) return { global: [], hk: [] };

  return data;
};
